export const dpi = window.devicePixelRatio || 1;
